<template>
  <div class="container mt-85">
    <div class="wrapper-merci center-align col l12">
      <h4 class="center-align">
        <span id="msgToShow"
              ref="messageFormRef"
              class="fw-400 fs-12 center-align"
              v-html="message"
        ></span>
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "Merci",
  props: {
    codeMsgForm: {
      type: String,
      required: true
    },
    paramsMsgForm: {
      type: Object,
      required: true
    },
    textErreur: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    message: ''
  }),
  methods: {
    setupMessage() {
      const messageDefault = 'confirmEnvoiMessageSuiviPart1';
      this.message = this.textErreur[this.codeMsgForm] || this.textErreur[messageDefault];

      // treat params : part of the message that must be replaced by specific info provided by the post data (inside paramsMsgForm)
      Object.keys(this.paramsMsgForm).forEach(key => {
        const msgResult1 = '<span class="' + key + '">';
        const msgResult2 = "<span class='" + key + "'>";

        // traité liens TODO: improve (demande fait de derniere minute, idealement il faut meuiller planifier ce lien)
        if (key === 'urlIsni' || key === 'urlForm') {
          if (this.message.indexOf(msgResult1) !== -1) {
            this.message = this.message.replace(
              msgResult1 + '</span>',
              '<a href="' + this.paramsMsgForm[key] + '">' + msgResult1 + '</span></a>'
            );
          } else if (this.message.indexOf(msgResult2) !== -1) {
            this.message = this.message.replace(
              msgResult2 + '</span>',
              '<a href="' + this.paramsMsgForm[key] + '">' + msgResult2 + '</span></a>'
            );
          }
        }

        // remplacer le contenu de la message
        if (this.message.indexOf(msgResult1) !== -1) {
          const newMessage1 = this.message.replace(msgResult1, msgResult1 + this.paramsMsgForm[key]);
          this.message = newMessage1;
        } else if (this.message.indexOf(msgResult2) !== -1) {
          const newMessage2 = this.message.replace(msgResult2, msgResult2 + this.paramsMsgForm[key]);
          this.message = newMessage2;
        }
      });
    }
  },
  mounted() {
    this.setupMessage();
  },
  watch: {
    textErreur: function() {
      this.setupMessage();
    }
  }
};
</script>
<style lang="scss" scoped>
.mt-85 {
  margin-top: 75px !important;
  padding-bottom: 75px !important;
}
.wrapper-merci {
  /*min-height: 250px;*/
  h4 {
  }
  .fs-12 {
    font-size: 20px;
  }
}
</style>
